import * as React from 'react';
import styled from 'styled-components';
import { SpaceProps, space, ResponsiveValue, display, DisplayProps } from 'styled-system';
import { is, media, themeGet, Spacer } from '@packages/ui';
import { SearchBarContainer, ABTestingContext } from '@packages/shared';

import { MainNavigation } from './MainNavigation/MainNavigation';
import { MenuBar } from './MenuBar/MenuBar';
import { IconNavigation } from './IconNavigation/IconNavigation';

const STICKY_HEADER_HEIGHT_MOBILE = '50px';
const STICKY_HEADER_HEIGHT_TABLET = '58px';

const StickyWrapper = styled.div<{ isSticky: boolean }>`
  position: relative;
  z-index: ${themeGet.zIndex('MIDDLE', 2)};
  ${media.to.lg`
    box-shadow: 0px 8px 8px -5px rgba(43, 18, 2, 0.3);
     width: 100%;
    ${is('isSticky')`
      position: fixed;
      top: 0;
      background: ${themeGet.colors('white')}
    `};
  `};
`;

/*
 * when header is in sticky mode (position: fixed - so it will also work on IE)
 * this will reserve some space so it won't overlap any content
 */
const StickySpacer = styled(Spacer)<{ isSticky: ResponsiveValue<boolean> }>`
  display: none;
  ${is('isSticky')`
    ${media.to.lg`
      display: block;
      margin-top: calc((${STICKY_HEADER_HEIGHT_TABLET}));
      ${media.to.md`
        margin-top: calc((${STICKY_HEADER_HEIGHT_MOBILE}));
      `}

    `}
  `}
`;

const NavigationWrapper = styled.div<SpaceProps>`
  margin: 0 auto;
  max-width: ${themeGet.content('maxWidth')};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > :first-child {
    flex: 0 0 144px;
  }
  ${space}
`;

const SearchBarWrapper = styled.div<{ isActive: boolean }>`
  transition: all 200ms ease-in-out;
  height: 100%;
  z-index: 2;

  ${media.to.lg`
    position: absolute;
    background-color: white;
    // just using the highest hight to hide the searchbar
    top: -${STICKY_HEADER_HEIGHT_TABLET};
    ${is('isActive')`
      top: 0px;
    `};
  `}
`;

const HeaderTag = styled.header<DisplayProps>`
  ${display}
`;

export const Header: React.FC = React.memo(() => {
  const [searchActive, setSearchActive] = React.useState(false);
  const {
    config: { STICKY_HEADER },
  } = React.useContext(ABTestingContext);

  const toggleSearch = () => {
    setSearchActive((state) => !state);
  };

  return (
    <>
      <HeaderTag display={['flex', 'flex', 'flex', 'block']}>
        <StickyWrapper isSticky={STICKY_HEADER}>
          {/* px should be aligned with `ContentContainer` - but there is also
        different settings in `CategoryPageTemplate`,
        `LocalDealerListTemplate` and `SearchPageTemplte` TODO: consolidate
        this. */}
          <NavigationWrapper px={[0, 0, 0, 2, 2, 3]} py={[1, 1, 0]}>
            <MenuBar />
            <SearchBarWrapper isActive={searchActive}>
              <SearchBarContainer isActive={searchActive} toggleSearch={toggleSearch} />
            </SearchBarWrapper>
            <IconNavigation toggleSearch={toggleSearch} />
          </NavigationWrapper>
        </StickyWrapper>
        <StickySpacer isSticky={STICKY_HEADER} />
        <MainNavigation />
      </HeaderTag>
    </>
  );
});

Header.displayName = 'Header';
